import {
    ColumnFilter,
    ColumnFilters,
    Pagination,
    SetUrlParamsFunction,
    TableSorting,
    UnknownObject,
} from '@shared/types';
import { TagID } from '@features/tags/types';
import { Module } from '@pages/modules/types';
import { useEffect } from 'react';
import { isEqual } from 'lodash';

type FilterParams = Partial<{
    globalFilter: string;
    sorting: TableSorting;
    columnFilters: ColumnFilters;
    tags: TagID[];
    pageIndex: Pagination['pageIndex'];
    pageSize: Pagination['pageSize'];
    module: Module['path'];
    modules: Array<Module['pk']>;
}>;

const useURLFilters = ({
    params,
    urlParams,
    setUrlParams,
    disableFilters,
}: {
    params: FilterParams;
    urlParams: UnknownObject;
    setUrlParams: SetUrlParamsFunction;
    disableFilters?: boolean;
}) => {
    const { globalFilter, sorting, columnFilters, tags, pageIndex, pageSize, module, modules } = params;

    useEffect(() => {
        if (disableFilters) {
            return;
        }

        const newUrlParams = {
            ...(globalFilter ? { globalFilter } : undefined),
            ...(sorting?.length ? { sorting: `${sorting[0].desc ? '-' : ''}${sorting[0].id}` } : undefined),
            ...(columnFilters?.length
                ? {
                      columnFilters: JSON.stringify(
                          columnFilters.map((item: ColumnFilter) => {
                              return {
                                  [item.id]: item.value,
                              };
                          }),
                      ),
                  }
                : undefined),
            ...(tags?.length ? { tags: JSON.stringify(tags) } : undefined),
            ...(pageIndex !== undefined ? { pageIndex: String(pageIndex) } : undefined),
            ...(pageSize !== undefined ? { pageSize: String(pageSize) } : undefined),
            ...(module ? { module } : undefined),
            ...(modules?.length ? { modules: JSON.stringify(modules) } : undefined),
        };

        if (!isEqual(urlParams, newUrlParams)) {
            setUrlParams(newUrlParams, { replace: true });
        }
    }, [
        columnFilters,
        globalFilter,
        sorting,
        urlParams,
        setUrlParams,
        tags,
        pageIndex,
        pageSize,
        module,
        modules,
        disableFilters,
    ]);
};

export default useURLFilters;
